import type { SiteContent } from "../api/content";
import { service, deck } from "../hooks/useContent";

/** Товарная часть события аналитики: что купили и за сколько. */
export type CatalogItem = {
  contentId: string;
  contentName: string;
  value: number;
  currency: string;
};

/** Цифровой ридинг продаётся как услуга CMS — цену берём оттуда, а не числом. */
export const READING_SERVICE_KEY = "digital-tarot-insight";

export function serviceItem(
  content: SiteContent | undefined,
  key: string,
): CatalogItem | null {
  const s = service(content, key);
  if (!s) return null;
  return {
    contentId: s.key,
    contentName: s.title,
    value: s.price,
    currency: s.currency,
  };
}

export function deckItem(
  content: SiteContent | undefined,
  key: string,
): CatalogItem | null {
  const d = deck(content, key);
  if (!d) return null;
  return {
    contentId: d.key,
    contentName: d.title,
    value: d.price,
    currency: d.currency,
  };
}

/** Заказ колод. Ключи приходят через запятую — так их склеивает
 *  backend/apps/shop/stripe_checkout.py и в success_url, и в metadata.
 *  Возвращает null, если хоть один ключ неизвестен: лучше не отправить
 *  событие, чем отправить его с заниженной суммой. */
export function deckOrderItem(
  content: SiteContent | undefined,
  keysCsv: string,
): CatalogItem | null {
  const keys = keysCsv
    .split(",")
    .map((k) => k.trim())
    .filter(Boolean);
  if (keys.length === 0) return null;

  const items = keys.map((k) => deckItem(content, k));
  if (items.some((i) => i === null)) return null;
  const found = items as CatalogItem[];

  return {
    contentId: keys.join(","),
    contentName: found.map((i) => i.contentName).join(" + "),
    value: found.reduce((sum, i) => sum + i.value, 0),
    currency: found[0].currency,
  };
}
